import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'

export const getSuggestionsListKey = (
  communityPath: string,
  postId?: number,
  displayNameSearchBy?: string,
): string => {
  const params = new URLSearchParams()

  if (displayNameSearchBy) {
    params.append('displayNameSearchBy', displayNameSearchBy)
  }

  if (postId) {
    params.append('postId', postId.toString())
  }

  return `${COMMUNITY_API_PREFIX}/${communityPath}/get-members-for-mention?${params.toString()}`
}
